// @ts-nocheck
import { Grip } from "./snaps/Grip";
import { Point } from "./Point";
import { TripH } from "./snaps/TripH";
import { TripV } from "./snaps/TripV";
import { SelectBoundary } from "./frames/SelectBoundary";
// --- other libraries --------------------------------
import { v4 as uuidv4 } from "uuid";
import { RouteCrucialPoints } from "../shared/types";
import { a } from "../shared/globalState/a";
import { Graf } from "./nets/GraphExtension";


export abstract class BasicShape {
    grip: any;
    private _id: any;
    abstract isSelected: boolean;
    isinArea: boolean;
    edit: boolean;
    move_mat: any;
    tripH: TripH;
    tripV: TripV
    selectBoundary: any;
    hidden: boolean;
    rtype: string;

    public abstract getCrucialPoints(): RouteCrucialPoints;

    set id(id) {
        this._id = id;
        this.grip.ownerId = id;
    }
    get id() {
        return this._id;
    }

    constructor() {
        this.isinArea = false;
        this.edit = null;

        this.move_mat = null;

        this.grip = new Grip(Point.ORIGIN, this.id);
        this.id = uuidv4();
        
        this.tripH = new TripH(Point.ORIGIN);
        this.tripV = new TripV(Point.ORIGIN);
        this.selectBoundary = new SelectBoundary(Point.ORIGIN, Point.ORIGIN, Point.ORIGIN, Point.ORIGIN);

        this.hidden = false;

        this.rtype = 'без типа';
        

    }

    getObject() {
        let json = JSON.stringify(this);
        let result = JSON.parse(json);
        result.id = this.id;
        return result;
    }

    setNewId() {
        this.id = uuidv4();
    }

    hasGraphNode(node: string) {
        const points = this.getCrucialPoints();
        const startMatches = !!points.start && points.start.id === node;
        const endMatches = !!points.end && points.end.id === node;
        const midMatches = !!points.mid && points.mid.id === node;
        const result = startMatches || endMatches || midMatches;
        return result;
    }

    /**
     * Finds and returns the graph that contains this shape's start point node.
     * @returns The graph containing this shape, or undefined if not found
     */
    getGraph() {

        
        
        try {
            // Validate that graphs array exists
            const graphs = a.graphs;
            if (!graphs || !Array.isArray(graphs)) {
                console.error('!! getGraph: graphs array is not available');
                return undefined;
            }

            // Get crucial points from the shape
            const crucialPoints = this.getCrucialPoints();
            if (!crucialPoints) {
                console.error('!! getGraph: crucialPoints is not available for shape', this.id);
                return undefined;
            }

            // Validate start point exists
            if (!crucialPoints.start) {
                console.error('!! getGraph: start point is not available in crucialPoints for shape', this.id);
                return undefined;
            }

            // Validate start point has an ID
            const node = crucialPoints.start.id;
            if (!node) {
                console.error('!! getGraph: start point ID is not available for shape', this.id);
                return undefined;
            }

            // Find and return the graph containing this node
            const graph = Graf.findGraph(graphs, [node]);
            
            if (!graph) {
                // This is not necessarily an error - the shape might not be in any graph yet
                console.warn(`getGraph: No graph found containing node ${node} for shape ${this.id}`);
            }
            
            return graph;
        } catch (error) {
            console.error('!! getGraph: Unexpected error occurred', error, 'for shape', this.id);
            return undefined;
        }
    }
}